import { render, staticRenderFns } from "./StudentBinding.vue?vue&type=template&id=d3c3ac12&scoped=true"
import script from "./StudentBinding.vue?vue&type=script&lang=js"
export * from "./StudentBinding.vue?vue&type=script&lang=js"
import style0 from "./StudentBinding.vue?vue&type=style&index=0&id=d3c3ac12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c3ac12",
  null
  
)

export default component.exports